import React, { useState, useEffect } from "react";
import { getS3URL } from "../../../../../../../_helpers";
import CourseFile from "../../../CourseFileUpload";
// import OverlayContainer from "../../../../../../Overlay/OverlayContainer";
// import CoursePreview from "../../../../../../Courses/CoursePreview/CoursePreview";
import CourseSectionDocument from "./CourseEditImage/CourseSectionDocument";
import { CourseSection } from "../CourseSection";
import { documentTypeUrl } from "../../../../../../../_constants/staticData";
import TextEditor from "../TextEditor";

const EditableChapter = ({
  title,
  add,
  fetchAll,
  content,
  formValues,
  history,
  files,
  handleEditorStateChange,
  index,
  handleInputChange,
  courseID,
  courseFile,
  setFormValues,
  isCurrentFileUploadStatus,
  isCurrentFileUpload,
}) => {
  const [isactive, setActive] = useState({
    richTextEditorShow: false,
    videoShow: false,
    imageShow: false,
    docShow: false,
    video: null,
  });

  const [isActive, setIsActive] = useState(false);

  const [showCoursePreview, setShowCoursePreview] = useState(false);

  const handleraccordion = () => {
    setIsActive(!isActive);
    setActive({ ...isactive, richTextEditorShow: false });
  };

  const refreshData = (values) => {
    fetchAll();
  };
  const [active, setshowActive] = useState(false);
  const handleAddCourseMaterial = (event) => {
    event.preventDefault();
    setshowActive((state) => !state);
  };

  const removeFormFields = (event, index, property) => {
    event.preventDefault();
    let newFormValues = [...formValues[property]];
    newFormValues.splice(index, 1);
    setFormValues({ ...formValues, [property]: newFormValues });
  };
  const courseFileAdd = (sectionIndex, addNewSection) => (content) => {
    if (content != null && typeof content == "object" && content.length > 0) {
      const previousCourseSection = [...addNewSection.courseSections];
      previousCourseSection[sectionIndex].files = content;
      setFormValues({
        ...formValues,
        courseSections: previousCourseSection,
      });
    }
  };
  return (
    <>
      <div className="accordion-item">
        {add && (
          <div className="accordion-title  mycoursedetails">
            <div>{!isactive.richTextEditorShow ? title : ""}</div>
            <div className="expn-elte-btn">
              <button
                className="course-chapter-expand"
                onClick={handleraccordion}
              >
                {isActive ? "Collapse" : "Expand"}
              </button>
              <button
                className="courseedit-delete"
                onClick={(event) =>
                  removeFormFields(event, index, "courseSections")
                }
              >
                Delete
              </button>
            </div>
          </div>
        )}
        {isActive && (
          <div className="accordion-content border-top-content">
            <div className="accordion-contentDescription-Course accordion-contentSection ">
              <div className="flex-end-accordin-new-para">
                <button
                  onClick={() =>
                    setActive((isactive) => ({
                      ...isActive,
                      richTextEditorShow: !isactive.richTextEditorShow,
                    }))
                  }
                >
                  {isactive.richTextEditorShow ? "Update -" : "Edit +"}
                </button>
              </div>
            </div>

            <div className="accordion-contentDescription-Course">
              {isactive.richTextEditorShow === false && (
                <>
                  <div>
                    <h4>Description</h4>
                    {content !== null && (
                      <span>
                        {content && (
                          <div
                            className="content-data"
                            dangerouslySetInnerHTML={{
                              __html: content,
                            }}
                          />
                        )}
                      </span>
                    )}
                    <div className="content-des-off">
                      <h4 className="edit-content-des">Vimeo Link</h4>
                      <span>{formValues.courseSections[index].videoLink}</span>
                    </div>
                  </div>
                </>
              )}

              {isactive.richTextEditorShow === true && (
                <>
                  <div className="rich-inputFeild">
                    <input
                      type="text"
                      name="courseSections"
                      value={formValues.courseSections[index].name}
                      onChange={({ target }) =>
                        handleInputChange(
                          index,
                          target.name,
                          target.value,
                          "name",
                          true
                        )
                      }
                    />
                    {formValues.courseSections && (
                      <TextEditor
                        formState={content}
                        history={history}
                        handleEditorStateChange={handleEditorStateChange(
                          "courseSections",
                          "description",
                          index
                        )}
                      />
                    )}
                    <div className="form-inline section-description">
                      <h4>Section {index + 1} - Video / Document Link</h4>
                      <input
                        type="text"
                        name="courseSections"
                        placeholder="Video / Document Link"
                        value={formValues.courseSections[index].videoLink}
                        onChange={({ target }) =>
                          handleInputChange(
                            index,
                            target.name,
                            target.value,
                            "videoLink",
                            true
                          )
                        }
                      />
                    </div>
                  </div>
                </>
              )}
            </div>
            <div>
              <CourseSectionDocument
                datasource={files}
                toogle={setShowCoursePreview}
                courseImg={
                  formValues.imageFiles.length < 0
                    ? getS3URL(formValues.imageFiles[0].fileName)
                    : documentTypeUrl.brokenImage
                }
                courseName={formValues.courseName && formValues.courseName}
                refreshData={refreshData}
              />

              <div className="define-add-text">
                <a
                  name={index}
                  href="javascript(void);"
                  onClick={handleAddCourseMaterial}
                >
                  + Add Course material
                </a>
              </div>

              {active && (
                <div className="chapter-section">
                  <div className="course-image-introductionSection">
                    <CourseFile
                      courseFileLimit={5 - files.length}
                      courseFile={courseFile}
                      courseId={courseID}
                      isCurrentFileUpload={isCurrentFileUpload}
                      isCurrentFileUploadStatus={isCurrentFileUploadStatus}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
        {add === undefined && (
          <CourseSection
            current={16}
            index={index}
            section={title}
            handleEditorStateChange={handleEditorStateChange}
            handleInputChange={handleInputChange}
            courseFile={courseFileAdd(index, formValues)}
            removeFormFields={removeFormFields}
            history={history}
            location={"courseEdit"}
          />
        )}
      </div>
      {/* {showCoursePreview && (
        <OverlayContainer>
          <CoursePreview
            courseName={formValues.courseName}
            courseImg={
              formValues.imageFiles &&
              getS3URL(formValues.imageFiles[0].fileName)
            }
            courseVid={isactive.video && getS3URL(isactive.video)}
            toogle={setShowCoursePreview}
          />
        </OverlayContainer>
      )} */}
    </>
  );
};
export default EditableChapter;
